import { Z } from "./query";

export namespace Flourishes {

    export function init() {
        Z.init<HTMLCanvasElement>('.h-then-img canvas.flourish-dot', 'flourish-dot', el => new FlourishDot(el));
    }

    class FlourishDot {
        canvas: HTMLCanvasElement;
        ctx: CanvasRenderingContext2D;
        container: HTMLElement;

        ddsbBrandNavyRgba(opacity: number = 1) {
            return `rgba(${getComputedStyle(document.body).getPropertyValue('--ddsb-brand-navy-rgb')}, ${opacity})`;
        }
        ddsbBrandCyanRgba(opacity: number = 1) {
            return `rgba(${getComputedStyle(document.body).getPropertyValue('--ddsb-brand-cyan-rgb')}, ${opacity})`;
        }
        ddsbBrandBlueRgba(opacity: number = 1) {
            return `rgba(${getComputedStyle(document.body).getPropertyValue('--ddsb-brand-blue-rgb')}, ${opacity})`;
        }
        ddsbBrandMagentaRgba(opacity: number = 1) {
            return `rgba(${getComputedStyle(document.body).getPropertyValue('--ddsb-brand-magenta-rgb')}, ${opacity})`;
        }

        get bounds() { return this.container.getBoundingClientRect(); }
        get panels() { return Z.selectFrom(this.container, '.overlay'); }

        ticker;
        tick() {
            clearTimeout(this.ticker);
            this.repaint();
            this.ticker = setTimeout(() => this.tick(), 1000);
        }

        constructor(canvas: HTMLCanvasElement) {
            this.canvas = canvas;
            this.ctx = canvas.getContext('2d');
            this.container = canvas.parentElement;

            document.addEventListener('resize', ev => {
                this.resize();
            });

            if (globalThis['ResizeObserver']) {
                let resizer = new globalThis['ResizeObserver'](cb => {
                    this.resize();
                });

                resizer.observe(this.canvas);
            }

            if (globalThis['IntersectionObserver']) {
                let intersector = new globalThis['IntersectionObserver'](cb => {
                    this.resize();
                });
                intersector.observe(this.canvas);
            }

            this.resize();
            this.tick();
        }

        resize() {
            let bounds = this.canvas.getBoundingClientRect();
            this.canvas.width = Math.round(bounds.width);
            this.canvas.height = Math.round(bounds.height);
            this.repaint();
        }

        get midX() { return this.canvas.width / 2; }
        get midY() { return this.canvas.height / 2; }

        repaint() {
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

            this.panels.forEach(panel => {
                let bounds = panel.getBoundingClientRect();
                let left = bounds.x - this.bounds.x;
                let top = bounds.y - this.bounds.y;
                let right = left + bounds.width;
                let bottom = top + bounds.height;
                let midX = left + bounds.width / 2;
                let midY = top + bounds.height / 2;

                let onLeft = left < this.midX;
                let onRight = !onLeft;

                let onTop = bottom < this.midY;

                this.ctx.strokeStyle = `${this.ddsbBrandMagentaRgba(1)}`;
                this.ctx.lineWidth = 3;
                this.ctx.lineCap = 'round';
                //this.ctx.strokeRect(left, top, bounds.width, bounds.height);

                let factor = 3;

                let srcX = onLeft ? right : left;
                let srcY = ((onTop ? top : midY) + midY) / 2;

                let dstX = (srcX + (this.midX * (factor - 1))) / factor;
                let dstY = (srcY + (this.midY * (factor - 1))) / factor;

                let subX1 = (srcX * 2 + dstX) / 3;
                let subX2 = (srcX + dstX * 2) / 3;

                let gradient = this.ctx.createLinearGradient(left, midY, dstX, dstY);
                //let gradient = this.ctx.createLinearGradient(0, 0, 0, this.ctx.canvas.height);
                gradient.addColorStop(0, this.ddsbBrandMagentaRgba(1));
                gradient.addColorStop(1, this.ddsbBrandBlueRgba(1));
                //gradient.addColorStop(1, 'white');

                //this.ctx.strokeStyle = `${this.ddsbBrandMagentaRgba(1)}`;
                this.ctx.strokeStyle = gradient;

                this.ctx.beginPath();
                this.ctx.moveTo(srcX, srcY);

                let step1 = { x: srcX, y: srcY };
                let step2 = { x: (subX1 + srcX) / 2, y: srcY };

                let step3 = { x: subX1, y: srcY };
                let step4 = { x: (subX1 + subX2) / 2, y: dstY };
                let step5 = { x: subX2, y: dstY };

                let step6 = { x: dstX, y: dstY };

                this.ctx.lineTo(step1.x, step1.y);
                this.ctx.lineTo(step2.x, step2.y);
                this.ctx.bezierCurveTo(step3.x, step3.y, step4.x, step4.y, step5.x, step5.y);

                this.ctx.lineTo(step6.x, step6.y);

                /*steps.forEach(step => {
                    this.ctx.lineTo(step[0], step[1]);
                });*/

                //this.ctx.lineTo(subX1, srcY);
                //this.ctx.lineTo(subX2, dstY);
                //this.ctx.bezierCurveTo(subX1, srcY, subX2, dstY, dstX, dstY);

                //this.ctx.lineTo(dstX, dstY);
                this.ctx.stroke();

                this.ctx.strokeStyle = this.ddsbBrandBlueRgba(1);

                this.ctx.beginPath();
                this.ctx.fillStyle = 'white';
                this.ctx.ellipse(dstX, dstY, 10, 10, 0, 0, Math.PI * 2, true);
                this.ctx.fill();
                this.ctx.stroke();

                this.ctx.fillStyle = this.ddsbBrandBlueRgba(1);
                this.ctx.beginPath();
                this.ctx.ellipse(dstX, dstY, 5, 5, 0, 0, Math.PI * 2, true);
                this.ctx.fill();

            });
        }
    }

}